import { getGlobalCssUrl } from '../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createPaginationTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<style>
.hide {
  display: none;
}
</style>
`
  return t;
}

const getTemplatePaginationStyles = () => createPaginationTemplate();
export { getTemplatePaginationStyles };
